import z from 'zod';

export const DataLayerObjectSchema = z
    .object({
        event: z.string().optional(),
    })
    .catchall(z.unknown());

export type DataLayerObject = z.infer<typeof DataLayerObjectSchema>;

declare global {
    interface Window {
        dataLayer?: DataLayerObject[];
    }
}

const trackingUrlParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'ireferrer',
    'lreferrer',
] as const;

export function pushToDataLayer(item: DataLayerObject) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push(item);
}

export const saveUtmParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlKeys = Array.from(urlParams.keys());

    const hasParams = trackingUrlParams.some((trackingKey) =>
        urlKeys.some((urlKey) => urlKey.toLowerCase() === trackingKey),
    );

    if (!hasParams) {
        return;
    }

    trackingUrlParams.forEach((trackingKey) => {
        const urlKey = urlKeys.find((key) => key.toLowerCase() === trackingKey);

        const value = (urlKey && urlParams.get(urlKey)) || '';

        localStorage.setItem(`berghs_${trackingKey}`, value);
    });
};

export const fillUtmParams = (form: HTMLFormElement) => {
    trackingUrlParams.forEach((name) => {
        const input = form.elements.namedItem(name);

        if (!(input instanceof HTMLInputElement)) {
            return;
        }

        const value = localStorage.getItem(`berghs_${name}`) || '';

        input.value = value;
    });
};
